import React, {Component} from "react"

import Flex from "@irati/ui/src/Flex"
import {H2} from "@irati/ui/src/Typography"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import FormattedMessage from "@irati/utils/lang"
import adminTracking from "@irati-tracking/admin/admin"

import {VIEW_TEAM} from "../../../routes/routeConfig"
import ShareLink from "../../ShareLink"

interface Props {
  source: string
}

interface State {}

class TeamEngagementHeader extends Component<Props, State> {
  handleTrackEvent = () => {
    adminTracking.reporting({
      source: this.props.source,
      type: "overall_teamAnalysis",
      action: "viewTeam"
    })
  }

  render() {
    return (
      <Flex justifyContent="space-between">
        <H2>
          <FormattedMessage id="admin.components.teamEngagement.header.title" />
        </H2>
        <Flex justifyContent="flex-end">
          <ShareLink />
          <ButtonRouterLink marginLeft primary to={VIEW_TEAM} onClick={this.handleTrackEvent}>
            <FormattedMessage id="admin.components.teamEngagement.header.button" />
          </ButtonRouterLink>
        </Flex>
      </Flex>
    )
  }
}

export default TeamEngagementHeader
